import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export const PopupResource = () => {
  return Vue.resource('popups{/id}')
}



// WEBPACK FOOTER //
// ./src/api/popup.js